import { Box, Button, Grid, Link, Typography } from '@mui/material';
import { useState } from 'react';
import OnboardingInput from './components/OnboardingInput';
import TestimonialsTwoCarousel from './components/TestimonialsCarousel';

export const ConfirmEmailOnboarding = () => {
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(undefined);

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          position: 'relative',
        }}
      >
        <Box sx={{ position: 'absolute', top: 32, left: 32 }}>
          <img
            src="/icon/artwork.svg"
            alt=""
            style={{ width: 100, height: 'auto' }}
          />
        </Box>
        <Box
          sx={{
            width: '100%',
            maxWidth: 420,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mt: 8,
          }}
        >
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="h4"
            fontWeight={700}
            fontSize={24}
            mb={1}
            align="center"
            sx={{ width: '100%' }}
          >
            What's your email address?
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="subtitle1"
            fontWeight={100}
            mb={4}
            align="center"
            sx={{ width: '100%' }}
          >
            We'll send a verification code to this number to confirm your
            identity.
          </Typography>
          <Box sx={{ width: '100%', maxWidth: 400, mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{ mb: 0.5, color: '#fff', fontWeight: 500 }}
            >
              Email
            </Typography>
            <OnboardingInput
              placeholder="Enter your email"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              type="email"
            />
          </Box>
          <Button
            variant="contained"
            sx={{
              fontSize: 16,
              mt: 2,
              p: 2,
              width: '100%',
              maxWidth: 400,
              backgroundColor: '#4949C8',
              color: '#fff',
              boxShadow: 'none',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 400,
              '&:hover': {
                backgroundColor: '#3535a8',
              },
            }}
          >
            Send verification code
          </Button>
          <Link
            href="#"
            color="#4949C8"
            underline="hover"
            sx={{ fontSize: 16, fontWeight: 400, mt: 3, mb: 1 }}
          >
            Sign up using phone number
          </Link>
          <Typography variant="body2" mt={2} textAlign="center" color="#fff">
            Already have an account?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Sign in
            </Link>
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 600, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            This is what we found about <br /> your business
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            We automatically pulled this info from your <br /> website.
          </Typography>
        </Box>
        <TestimonialsTwoCarousel />
      </Grid>
    </Grid>
  );
};
